import React, { ReactNode } from 'react';
import { SpinningLoadingIcon } from '~/libs/ui/atoms/SpinningLoadingIcon';

export interface ButtonSaveProps {
	disabled?: boolean;
	loading?: boolean;
	children?: ReactNode;
	onClick?: () => void;
}

export function ButtonSave({ disabled, loading, children, onClick }: ButtonSaveProps) {
	return (
		<button
			className='btn-default disabled:opacity-25 disabled:pointer-events-none'
			disabled={disabled}
			type='submit'
			onClick={onClick}
		>
			{loading ? (
				<SpinningLoadingIcon className='h-4 w-4' />
			) : (
				<svg
					className='inline-block relative -mt-0.5 h-4 w-4'
					fill='none'
					stroke='currentColor'
					viewBox='0 0 24 24'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						d='M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4'
						strokeLinecap='round'
						strokeLinejoin='round'
						strokeWidth='2'
					></path>
				</svg>
			)}
			&nbsp;{children}
		</button>
	);
}
